import { Component, inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { RouterUrlsEnum } from '../../enums/router-urls.enum';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'bodyanalytics-login-button',
  templateUrl: './login-button.component.html',
  imports: [MatIconModule, MatButtonModule],
  // Shared with the sibling logout button — see ../nav-text-link.scss.
  styleUrls: ['../nav-text-link.scss'],
})
export class LoginButtonComponent {
  private router = inject(Router);

  protected loginLink = RouterUrlsEnum.LOGIN;

  protected auth = inject(AuthService);

  login() {
    this.router.navigate([`${this.loginLink}`]);
  }
}
